<script lang="ts">
	import Icon from '$lib/elements/Icon.svelte';
	import { t } from 'svelte-i18n';
	import { formatDateWithLocale, getYearFromDate } from "$lib/utils/date";
	import { tooltipAction } from '$lib/actions/tooltip';
	import { capitalize, formatAmountWithCurrency } from '$lib/utils/strings';

	export let props;
</script>

<div class="flex items-center space-x-3 md:space-x-4">
	<div class="flex items-center space-x-2">
		<div class="inline-block text-premium">
			{#if props.operationTrancheAgeDate}
				<Icon name="calendar" classNames="flex-shrink-0" size="small" />
			{:else}
				<Icon name="euro" classNames="flex-shrink-0" size="small" />
			{/if}
		</div>
		<span class="font-semibold">
			{#if props.operationTrancheAgeDate}
				<span class="capitalize">
					{formatDateWithLocale(props.operationTrancheAgeDate, 'LLLL')}
				</span>
				{getYearFromDate(props.operationTrancheAgeDate)}
			{:else}
				<span
					class="tracking-normal"
					use:tooltipAction={{
						title: capitalize($t('operation.amountToSeek'))
					}}
				>
					{formatAmountWithCurrency(props.amountToSeek)}
				</span>
			{/if}
		</span>
	</div>
	<div class="flex items-center space-x-2">
		<div class="inline-block text-primary">
			<Icon name="favorite" classNames="flex-shrink-0" size="small" />
		</div>
		<span>
			<strong>{props.projectNbFavorites}</strong>
			{$t('operation.interested')}
		</span>
	</div>
</div>
